export const NPC_DJS = [
  { 
    id: 'dj_shadow', 
    name: 'DJ Shadow', 
    style: 'Riddim', 
    skinTone: '#3D2314',
    outfit: { top: 'led_jacket', pants: 'glow_purple', shoes: 'cyber_boots', hat: 'headphones' },
    mood: 'demon',
    eyeColor: '#DC2626'
  },
  { 
    id: 'dj_neon', 
    name: 'DJ Neon', 
    style: 'Dubstep', 
    skinTone: '#FFE0BD',
    outfit: { top: 'cyber_vest', pants: 'glow_cyan', shoes: 'glow_cyan', hat: 'led_visor' },
    mood: 'led',
    eyeColor: '#06B6D4'
  },
  { 
    id: 'dj_void', 
    name: 'DJ Void', 
    style: 'Dark Bass', 
    skinTone: '#5C4033',
    outfit: { top: 'demon_top', pants: 'chain_pants', shoes: 'demon_boots', hat: 'demon_horns' },
    mood: 'void',
    eyeColor: '#9333EA'
  },
  { 
    id: 'dj_cyber', 
    name: 'DJ Cyber', 
    style: 'Future Bass', 
    skinTone: '#D4A574',
    outfit: { top: 'holographic', pants: 'cyber_pants', shoes: 'holo_shoes', hat: 'cyber_helmet' },
    mood: 'tripping',
    eyeColor: '#22D3EE'
  },
];

// ==================== QUICK REACTIONS ====================
export const QUICK_REACTIONS = [
  { id: 'fire', emoji: '🔥', color: '#F97316' },
  { id: 'heart', emoji: '❤️', color: '#EF4444' },
  { id: 'thumbsup', emoji: '👍', color: '#22C55E' },
  { id: 'clap', emoji: '👏', color: '#FCD34D' },
  { id: 'star', emoji: '⭐', color: '#FCD34D' },
  { id: 'skull', emoji: '💀', color: '#9333EA' },
  { id: 'eyes', emoji: '👀', color: '#06B6D4' },
  { id: 'hundred', emoji: '💯', color: '#DC2626' },
];

// ==================== VIP PERKS ====================
export const VIP_PERKS = {
  owner: {
    nameColor: '#DC2626',
    nameBorder: true,
    nameGlow: '#DC2626',
    crownIcon: '👑',
    particleColor: '#FCD34D',
    exclusiveEmotes: ['throne', 'money_rain', 'spotlight'],
  },
  admin: {
    nameColor: '#9333EA',
    nameBorder: true,
    nameGlow: '#9333EA',
    crownIcon: '⚡',
    particleColor: '#9333EA',
    exclusiveEmotes: ['lightning', 'bass_drop'],
  },
  overseer: {
    nameColor: '#06B6D4',
    nameBorder: true,
    nameGlow: '#06B6D4',
    crownIcon: '🛡️',
    particleColor: '#06B6D4',
    exclusiveEmotes: ['shield'],
  },
  artist: {
    nameColor: '#EC4899',
    nameBorder: false,
    nameGlow: '#EC4899',
    crownIcon: '🎵',
    particleColor: '#EC4899',
    exclusiveEmotes: ['mic_drop'],
  },
};

// ==================== VIBECOINS & GIFTS ====================
export const NIGHTCLUB_GIFT_COSTS = {
  drink: 10,
  flowers: 25,
  confetti: 50,
  spotlight: 100,
  crown: 200,
};

export const NIGHTCLUB_GIFT_EMOJIS = {
  drink: '🍹',
  flowers: '💐',
  confetti: '🎊',
  spotlight: '🔦',
  crown: '👑',
};

// ==================== DANCE FLOOR SPOTLIGHT ====================
export const SPOTLIGHT_ZONE = {
  x: 400, // Center of dance floor
  y: 400,
  radius: 100,
  bonusEffects: true,
};

// ==================== ROOMS/VIP AREAS ====================
export const CLUB_ROOMS = [
  { 
    id: 'main', 
    name: 'Main Floor', 
    description: 'The main dance floor with DJ and LED screen', 
    isVIP: false, 
    maxPlayers: 50,
    theme: {
      floorColor1: '#1a1a2e',
      floorColor2: '#0f0f1a',
      gridColor: 'rgba(147, 51, 234, 0.15)',
      accentColor: '#9333EA',
      ambientColor: 'rgba(147, 51, 234, 0.1)',
      wallGraffiti: ['RIDDIM', 'DUBSTEP', 'BASS'],
      showDJ: true,
      showLEDScreen: true,
      showSpeakers: true
    }
  },
  { 
    id: 'vip_lounge', 
    name: 'VIP Lounge', 
    description: 'Exclusive gold & red luxury lounge', 
    isVIP: true, 
    requiredRole: ['owner', 'admin', 'overseer'], 
    maxPlayers: 20,
    theme: {
      floorColor1: '#2d1f1f',
      floorColor2: '#1a0f0f',
      gridColor: 'rgba(255, 215, 0, 0.2)',
      accentColor: '#FFD700',
      ambientColor: 'rgba(255, 215, 0, 0.08)',
      wallGraffiti: ['VIP', 'ELITE', '👑'],
      hasVelvetRopes: true,
      hasChandeliers: true,
      showDJ: false,
      showLEDScreen: false,
      showSpeakers: false
    }
  },
  { 
    id: 'backstage', 
    name: 'Backstage', 
    description: 'Artist greenroom with equipment', 
    isVIP: true, 
    requiredRole: ['owner', 'admin', 'overseer', 'artist'], 
    maxPlayers: 10,
    theme: {
      floorColor1: '#1a1a1a',
      floorColor2: '#0d0d0d',
      gridColor: 'rgba(100, 100, 100, 0.2)',
      accentColor: '#4ADE80',
      ambientColor: 'rgba(74, 222, 128, 0.05)',
      wallGraffiti: ['CREW', 'STAFF', '🎤'],
      hasEquipmentCases: true,
      hasCables: true,
      showDJ: false,
      showLEDScreen: false,
      showSpeakers: false
    }
  },
  { 
    id: 'chill_zone', 
    name: 'Chill Zone', 
    description: 'Relaxed lounge with ambient vibes', 
    isVIP: false, 
    maxPlayers: 30,
    theme: {
      floorColor1: '#0f1a2e',
      floorColor2: '#0a1020',
      gridColor: 'rgba(34, 211, 238, 0.1)',
      accentColor: '#22D3EE',
      ambientColor: 'rgba(34, 211, 238, 0.06)',
      wallGraffiti: ['CHILL', 'VIBES', '✨'],
      hasLoungeSeating: true,
      showDJ: false,
      showLEDScreen: true,
      showSpeakers: false
    }
  },
  { 
    id: 'rooftop', 
    name: 'Rooftop Terrace', 
    description: 'Exclusive rooftop with city views & trees', 
    isVIP: true, 
    requiredRole: ['owner', 'admin', 'overseer'],
    accessViaElevator: true,
    maxPlayers: 15,
    theme: {
      floorColor1: '#1a2f1a',
      floorColor2: '#0f1f0f',
      gridColor: 'rgba(134, 239, 172, 0.15)',
      accentColor: '#86EFAC',
      ambientColor: 'rgba(134, 239, 172, 0.08)',
      wallGraffiti: [],
      hasTrees: true,
      hasStars: true,
      hasCityView: true,
      hasStringLights: true,
      showDJ: false,
      showLEDScreen: false,
      showSpeakers: false
    }
  },
  { 
    id: 'visualizer', 
    name: 'Visualizer Room', 
    description: 'Immersive audio-reactive visual experience', 
    isVIP: false, 
    maxPlayers: 25,
    theme: {
      floorColor1: '#0a0015',
      floorColor2: '#050008',
      gridColor: 'rgba(147, 51, 234, 0.15)',
      accentColor: '#A855F7',
      ambientColor: 'rgba(147, 51, 234, 0.1)',
      wallGraffiti: [],
      hasVisualizer: true,
      showDJ: false,
      showLEDScreen: false,
      showSpeakers: true
    }
  },
  {
    id: 'apartments',
    name: 'Apartments',
    description: 'Rent your own room — 100 VC/week, your name in gold on the door',
    isVIP: false,
    maxPlayers: 30,
    theme: {
      floorColor1: '#241a10',
      floorColor2: '#171009',
      gridColor: 'rgba(251, 191, 36, 0.12)',
      accentColor: '#FBBF24',
      ambientColor: 'rgba(251, 191, 36, 0.06)',
      wallGraffiti: [],
      showDJ: false,
      showLEDScreen: false,
      showSpeakers: false
    }
  },
  { 
    id: 'city',
    name: 'City Block',
    description: 'Step outside — rent houses (250 VC), the Grand Mansion, and stroll 4 neighborhoods',
    isVIP: false,
    maxPlayers: 40,
    theme: {
      floorColor1: '#26262c',
      floorColor2: '#141221',
      gridColor: 'rgba(147, 197, 253, 0.12)',
      accentColor: '#93C5FD',
      ambientColor: 'rgba(147, 197, 253, 0.06)',
      wallGraffiti: [],
      showDJ: false,
      showLEDScreen: false,
      showSpeakers: false
    }
  },
];

// Avatar customization options - EXPANDED to 20+ items
export const SKIN_TONES = [
  { id: 'pale', name: 'Pale', color: '#FFF0E0' },
  { id: 'light', name: 'Light', color: '#FFE0BD' },
  { id: 'fair', name: 'Fair', color: '#F5D0B5' },
  { id: 'rosy', name: 'Rosy', color: '#F4C2A8' },
  { id: 'medium', name: 'Medium', color: '#D4A574' },
  { id: 'olive', name: 'Olive', color: '#C4A067' },
  { id: 'tan', name: 'Tan', color: '#A67B5B' },
  { id: 'sun_kissed', name: 'Sun Kissed', color: '#B5824A' },
  { id: 'brown', name: 'Brown', color: '#8D5524' },
  { id: 'mocha', name: 'Mocha', color: '#6F4E37' },
  { id: 'dark', name: 'Dark', color: '#5C4033' },
  { id: 'deep', name: 'Deep', color: '#3D2314' },
  { id: 'ebony', name: 'Ebony', color: '#2A1810' },
  // Stylized
  { id: 'undead', name: 'Undead', color: '#A8B5A0' },
  { id: 'cyber_white', name: 'Cyber Pale', color: '#E8DDF5' },
  { id: 'demon_red', name: 'Demon Red', color: '#A64646' },
];

export const FACE_MOODS = [
  { id: 'neutral', name: 'Neutral', emoji: '😐' },
  { id: 'sad', name: 'Sad', emoji: '😢' },
  { id: 'drowsy', name: 'Drowsy', emoji: '😴' },
  { id: 'tripping', name: 'Tripping', emoji: '🤯' },
  { id: 'demon', name: 'Demon Grin', emoji: '😈' },
  { id: 'skull', name: 'Skull', emoji: '💀' },
  { id: 'led', name: 'LED Mouth', emoji: '🤖' },
  { id: 'void', name: 'Void', emoji: '👁️' },
];

// P2: Hair styles
export const HAIR_STYLES = [
  { id: 'none', name: 'None', type: 'none' },
  { id: 'short', name: 'Short', type: 'short' },
  { id: 'buzz', name: 'Buzz Cut', type: 'buzz' },
  { id: 'mohawk', name: 'Mohawk', type: 'mohawk' },
  { id: 'long', name: 'Long', type: 'long' },
  { id: 'ponytail', name: 'Ponytail', type: 'ponytail' },
  { id: 'curly', name: 'Curly', type: 'curly' },
  { id: 'spiky', name: 'Spiky', type: 'spiky' },
];

// P2: Hair colors
export const HAIR_COLORS = [
  { id: 'black', name: 'Black', color: '#1a1a1a' },
  { id: 'brown', name: 'Brown', color: '#4a3728' },
  { id: 'blonde', name: 'Blonde', color: '#d4a76a' },
  { id: 'red', name: 'Red', color: '#8b2500' },
  { id: 'purple', name: 'Purple', color: '#9333EA' },
  { id: 'pink', name: 'Pink', color: '#EC4899' },
  { id: 'blue', name: 'Blue', color: '#3b82f6' },
  { id: 'neon', name: 'Neon', color: '#39FF14', glow: '#39FF14' },
];

export const EYE_COLORS = [
  { id: 'purple', name: 'Purple', color: '#9333EA' },
  { id: 'red', name: 'Red', color: '#EF4444' },
  { id: 'green', name: 'Green', color: '#22C55E' },
  { id: 'cyan', name: 'Cyan', color: '#06B6D4' },
  { id: 'white', name: 'White', color: '#FFFFFF' },
  { id: 'pink', name: 'Pink', color: '#EC4899' },
  { id: 'orange', name: 'Orange', color: '#F97316' },
];

// FACE ACCESSORIES - glasses, masks, jewelry
export const FACE_ACCESSORIES = [
  { id: 'none', name: 'None', type: 'none' },
  { id: 'cyber_glasses', name: 'Cyber Glasses', type: 'glasses', color: '#06B6D4', glow: '#06B6D4' },
  { id: 'round_glasses', name: 'Round Glasses', type: 'glasses', color: '#FCD34D' },
  { id: 'shutter_shades', name: 'Shutter Shades', type: 'glasses', color: '#1a1a1a' },
  { id: 'led_glasses', name: 'LED Glasses', type: 'glasses', color: '#9333EA', glow: '#9333EA' },
  { id: 'heart_glasses', name: 'Heart Glasses', type: 'glasses', color: '#EC4899' },
  { id: 'gas_mask', name: 'Gas Mask', type: 'mask', color: '#374151' },
  { id: 'half_mask', name: 'Half Mask', type: 'mask', color: '#1a1a1a' },
  { id: 'neon_mask', name: 'Neon Mask', type: 'mask', color: '#22D3EE', glow: '#22D3EE' },
  { id: 'skull_mask', name: 'Skull Mask', type: 'mask', color: '#E5E5E5' },
  { id: 'demon_mask', name: 'Demon Mask', type: 'mask', color: '#DC2626', glow: '#DC2626' },
  { id: 'nose_ring', name: 'Nose Ring', type: 'jewelry', color: '#FCD34D' },
  { id: 'septum', name: 'Septum', type: 'jewelry', color: '#A3A3A3' },
  { id: 'lip_ring', name: 'Lip Ring', type: 'jewelry', color: '#A3A3A3' },
  { id: 'face_chain', name: 'Face Chain', type: 'jewelry', color: '#FCD34D' },
  { id: 'led_earrings', name: 'LED Earrings', type: 'jewelry', color: '#9333EA', glow: '#9333EA' },
  { id: 'spike_earrings', name: 'Spike Earrings', type: 'jewelry', color: '#6B7280' },
  { id: 'hoop_earrings', name: 'Hoop Earrings', type: 'jewelry', color: '#FCD34D' },
  { id: 'cyber_implant', name: 'Cyber Implant', type: 'jewelry', color: '#06B6D4', glow: '#06B6D4' },
  { id: 'third_eye', name: 'Third Eye', type: 'jewelry', color: '#9333EA', glow: '#9333EA' },
];

// DANCE EMOTES - Enhanced with longer durations for full-body animations
export const DANCE_EMOTES = [
  { id: 'wave', name: 'Wave', icon: '\u{1F44B}', duration: 3000 },
  { id: 'dance1', name: 'Head Bob', icon: '\u{1F3B5}', duration: 4000 },
  { id: 'dance2', name: 'Shuffle', icon: '\u{1F57A}', duration: 5000 },
  { id: 'dance3', name: 'Jump', icon: '\u2B06\uFE0F', duration: 3000 },
  { id: 'spin', name: 'Spin', icon: '\u{1F504}', duration: 3000 },
  { id: 'headbang', name: 'Headbang', icon: '\u{1F918}', duration: 4000 },
  { id: 'dab', name: 'Dab', icon: '\u{1F4AA}', duration: 2500 },
  { id: 'clap', name: 'Clap', icon: '\u{1F44F}', duration: 3000 },
  { id: 'point', name: 'Point Up', icon: '\u261D\uFE0F', duration: 2500 },
  { id: 'heart', name: 'Heart', icon: '\u2764\uFE0F', duration: 3000 },
  { id: 'robot', name: 'Robot', icon: '\u{1F916}', duration: 5000 },
  { id: 'moonwalk', name: 'Moonwalk', icon: '\u{1F31C}', duration: 5000 },
  { id: 'breakdance', name: 'Breakdance', icon: '\u{1F525}', duration: 5000 },
  { id: 'floss', name: 'Floss', icon: '\u{1FA77}', duration: 4000 },
  { id: 'running_man', name: 'Running Man', icon: '\u{1F3C3}', duration: 4000 },
  { id: 'disco', name: 'Disco', icon: '\u{1FA69}', duration: 5000 },
  { id: 'salsa', name: 'Salsa', icon: '\u{1F483}', duration: 5000 },
  { id: 'pop_lock', name: 'Pop & Lock', icon: '\u26A1', duration: 4000 },
  { id: 'worm', name: 'The Worm', icon: '\u{1F40D}', duration: 4000 },
  { id: 'chicken', name: 'Chicken', icon: '\u{1F414}', duration: 4000 },
  { id: 'twerk', name: 'Twerk', icon: '\u{1F351}', duration: 4000 },
  { id: 'macarena', name: 'Macarena', icon: '\u{1F389}', duration: 5000 },
];

// EXPANDED OUTFIT OPTIONS - inspired by the character roster
export const OUTFIT_TOPS = [
  { id: 'tank_black', name: 'Black Tank', color: '#1a1a1a' },
  { id: 'tank_purple', name: 'Purple Tank', color: '#7C3AED' },
  { id: 'tank_red', name: 'Red Tank', color: '#DC2626' },
  { id: 'crop_black', name: 'Black Crop', color: '#0a0a0a' },
  { id: 'crop_neon', name: 'Neon Crop', color: '#22D3EE', glow: '#22D3EE' },
  { id: 'harness', name: 'Harness', color: '#374151' },
  { id: 'fishnet', name: 'Fishnet', color: '#1F2937' },
  { id: 'oversized_black', name: 'Oversized Tee', color: '#1a1a1a' },
  { id: 'oversized_white', name: 'White Tee', color: '#E5E5E5' },
  { id: 'cyber_vest', name: 'Cyber Vest', color: '#4C1D95', glow: '#9333EA' },
  { id: 'led_jacket', name: 'LED Jacket', color: '#1a1a1a', glow: '#06B6D4' },
  { id: 'rave_hoodie', name: 'Rave Hoodie', color: '#374151' },
  { id: 'spiked_vest', name: 'Spiked Vest', color: '#1a1a1a' },
  { id: 'trench_open', name: 'Trench (Open)', color: '#1F2937' },
  { id: 'trench_closed', name: 'Trench (Closed)', color: '#1F2937' },
  { id: 'demon_top', name: 'Demon Top', color: '#7F1D1D', glow: '#DC2626' },
  { id: 'skeleton_tee', name: 'Skeleton Tee', color: '#0a0a0a' },
  { id: 'holographic', name: 'Holographic', color: '#6366F1', glow: '#A78BFA' },
  { id: 'fur_coat', name: 'Fur Coat', color: '#44403C' },
  { id: 'mesh_top', name: 'Mesh Top', color: '#27272A' },
  // ========== NEW: Roster-inspired tops ==========
  { id: 'denim_jacket', name: 'Denim Jacket', color: '#4F71A8' },
  { id: 'plaid_red', name: 'Plaid Red Shirt', color: '#B91C1C' },
  { id: 'plaid_black', name: 'Plaid Black Shirt', color: '#27272A' },
  { id: 'leather_biker', name: 'Biker Leather', color: '#171717' },
  { id: 'olive_jacket', name: 'Olive Field Jacket', color: '#5A6B3D' },
  { id: 'army_jacket', name: 'Army Jacket', color: '#3F4A2A' },
  { id: 'hivis_vest', name: 'Hi-Vis Vest', color: '#FACC15', glow: '#FACC15' },
  { id: 'striped_tee', name: 'Striped Tee', color: '#F5F5F5' },
  { id: 'hawaiian_red', name: 'Hawaiian (Red)', color: '#E11D48' },
  { id: 'hawaiian_yellow', name: 'Hawaiian (Yellow)', color: '#F59E0B' },
  { id: 'brown_trench', name: 'Brown Trench Coat', color: '#78492A' },
  { id: 'skull_tank', name: 'Skull Tank', color: '#FAFAFA' },
  { id: 'suit_gray', name: 'Gray Suit', color: '#52525B' },
  { id: 'suit_navy', name: 'Navy Suit', color: '#1E3A8A' },
  { id: 'suit_purple', name: 'Purple Suit', color: '#6D28D9' },
  { id: 'suit_red_track', name: 'Red Tracksuit', color: '#DC2626' },
  { id: 'green_hoodie_circuit', name: 'Circuit Hoodie', color: '#15803D', glow: '#22C55E' },
  { id: 'camo_jacket', name: 'Camo Jacket', color: '#4D7C0F' },
  { id: 'lab_coat', name: 'Lab Coat', color: '#F9FAFB' },
  { id: 'dragon_tee', name: 'Dragon Tee', color: '#15803D' },
  { id: 'mechanic_overalls', name: 'Mechanic Overalls', color: '#7C7C7C' },
  { id: 'aviator_jacket', name: 'Aviator Jacket', color: '#5C4732' },
  { id: 'cop_uniform', name: 'Officer Uniform', color: '#1E40AF' },
  { id: 'anarchy_tee', name: 'Anarchy Tee', color: '#0a0a0a' },
  { id: 'rain_jacket', name: 'Yellow Rain Jacket', color: '#EAB308' },
  { id: 'karate_gi', name: 'Karate Gi', color: '#FAFAFA' },
  { id: 'turtleneck', name: 'Black Turtleneck', color: '#27272A' },
  { id: 'poncho', name: 'Poncho', color: '#15803D' },
  { id: 'astronaut_suit', name: 'Astronaut Suit', color: '#E5E7EB', glow: '#FFFFFF' },
  { id: 'prison_stripes', name: 'Prison Stripes', color: '#FAFAFA' },
  { id: 'sailor_uniform', name: 'Sailor Uniform', color: '#FAFAFA' },
  { id: 'denim_overalls', name: 'Denim Overalls', color: '#4F71A8' },
  { id: 'ninja_black', name: 'Ninja (Black)', color: '#0a0a0a' },
  { id: 'construction_vest', name: 'Construction Vest', color: '#F59E0B', glow: '#FACC15' },
  { id: 'wizard_robe', name: 'Wizard Robe', color: '#7C3AED' },
  { id: 'elf_tunic', name: 'Elf Tunic', color: '#16A34A' },
  { id: 'knight_armor', name: 'Knight Armor', color: '#B91C1C', glow: '#FCD34D' },
  { id: 'steampunk', name: 'Steampunk', color: '#92400E', glow: '#F59E0B' },
];

export const OUTFIT_PANTS = [
  { id: 'cargo_dark', name: 'Dark Cargo', color: '#374151' },
  { id: 'cargo_green', name: 'Green Cargo', color: '#166534' },
  { id: 'cargo_camo', name: 'Camo Cargo', color: '#4D7C0F' },
  { id: 'baggy_black', name: 'Baggy Black', color: '#0a0a0a' },
  { id: 'baggy_purple', name: 'Baggy Purple', color: '#581C87' },
  { id: 'chain_pants', name: 'Chain Pants', color: '#1F2937' },
  { id: 'glow_purple', name: 'Glow Purple', color: '#1a1a1a', glow: '#9333EA' },
  { id: 'glow_cyan', name: 'Glow Cyan', color: '#1a1a1a', glow: '#06B6D4' },
  { id: 'glow_red', name: 'Glow Red', color: '#1a1a1a', glow: '#DC2626' },
  { id: 'skinny_black', name: 'Skinny Black', color: '#0a0a0a' },
  { id: 'ripped_jeans', name: 'Ripped Jeans', color: '#1E3A5F' },
  { id: 'leather_pants', name: 'Leather Pants', color: '#1C1917' },
  { id: 'cyber_pants', name: 'Cyber Pants', color: '#18181B', glow: '#22D3EE' },
  { id: 'furry_warmers', name: 'Furry Warmers', color: '#44403C' },
  { id: 'skeleton_pants', name: 'Skeleton Pants', color: '#0a0a0a' },
  { id: 'reflective', name: 'Reflective', color: '#A3A3A3' },
  { id: 'wide_leg', name: 'Wide Leg', color: '#27272A' },
  { id: 'joggers', name: 'Joggers', color: '#1F2937' },
  { id: 'shorts', name: 'Shorts', color: '#0a0a0a' },
  { id: 'skirt', name: 'Rave Skirt', color: '#7C3AED' },
  // ========== NEW: Roster-inspired pants ==========
  { id: 'blue_jeans', name: 'Classic Blue Jeans', color: '#3B5998' },
  { id: 'khaki', name: 'Khaki Pants', color: '#A0875E' },
  { id: 'cargo_olive', name: 'Olive Cargo', color: '#5A6B3D' },
  { id: 'red_track_pants', name: 'Red Track Pants', color: '#DC2626' },
  { id: 'white_pants', name: 'White Pants', color: '#FAFAFA' },
  { id: 'astronaut_pants', name: 'Astronaut Pants', color: '#E5E7EB', glow: '#FFFFFF' },
  { id: 'prison_stripe_pants', name: 'Prison Pants', color: '#FAFAFA' },
  { id: 'sailor_pants', name: 'Sailor Pants', color: '#FAFAFA' },
  { id: 'denim_overall_pants', name: 'Denim Overall', color: '#4F71A8' },
  { id: 'wizard_robe_pants', name: 'Wizard Robe', color: '#7C3AED' },
  { id: 'knight_greaves', name: 'Knight Greaves', color: '#B91C1C', glow: '#FCD34D' },
];

export const OUTFIT_SHOES = [
  { id: 'platform_black', name: 'Platform Black', color: '#1a1a1a' },
  { id: 'platform_white', name: 'Platform White', color: '#E5E5E5' },
  { id: 'rave_green', name: 'Rave Green', color: '#84CC16' },
  { id: 'rave_pink', name: 'Rave Pink', color: '#EC4899' },
  { id: 'cyber_boots', name: 'Cyber Boots', color: '#7C3AED', glow: '#9333EA' },
  { id: 'spiked_boots', name: 'Spiked Boots', color: '#DC2626' },
  { id: 'glow_cyan', name: 'Glow Cyan', color: '#06B6D4', glow: '#06B6D4' },
  { id: 'glow_purple', name: 'Glow Purple', color: '#9333EA', glow: '#9333EA' },
  { id: 'combat_boots', name: 'Combat Boots', color: '#1C1917' },
  { id: 'sneakers_white', name: 'Sneakers White', color: '#F5F5F5' },
  { id: 'sneakers_black', name: 'Sneakers Black', color: '#0a0a0a' },
  { id: 'fur_boots', name: 'Fur Boots', color: '#78716C' },
  { id: 'demon_boots', name: 'Demon Boots', color: '#7F1D1D', glow: '#DC2626' },
  { id: 'skeleton_kicks', name: 'Skeleton Kicks', color: '#0a0a0a' },
  { id: 'holo_shoes', name: 'Holo Shoes', color: '#6366F1', glow: '#A78BFA' },
  { id: 'chunky_black', name: 'Chunky Black', color: '#18181B' },
  { id: 'slides', name: 'Slides', color: '#374151' },
  { id: 'barefoot', name: 'Barefoot', color: 'transparent' },
  { id: 'led_shoes', name: 'LED Shoes', color: '#1a1a1a', glow: '#22D3EE' },
  { id: 'roller_blades', name: 'Roller Blades', color: '#F97316' },
];

export const OUTFIT_HATS = [
  { id: 'none', name: 'None', color: 'transparent' },
  { id: 'beanie_black', name: 'Beanie Black', color: '#1a1a1a' },
  { id: 'beanie_purple', name: 'Beanie Purple', color: '#7C3AED' },
  { id: 'demon_horns', name: 'Demon Horns', color: '#DC2626' },
  { id: 'demon_horns_black', name: 'Black Horns', color: '#1a1a1a' },
  { id: 'led_visor', name: 'LED Visor', color: '#06B6D4', glow: '#06B6D4' },
  { id: 'led_visor_pink', name: 'Pink Visor', color: '#EC4899', glow: '#EC4899' },
  { id: 'spiked_helmet', name: 'Spiked Helmet', color: '#374151' },
  { id: 'hood_up', name: 'Hood Up', color: '#1F2937' },
  { id: 'cat_ears', name: 'Cat Ears', color: '#1a1a1a' },
  { id: 'bunny_ears', name: 'Bunny Ears', color: '#FFC0CB' },
  { id: 'halo', name: 'Halo', color: '#FCD34D', glow: '#FCD34D' },
  { id: 'devil_halo', name: 'Devil Halo', color: '#DC2626', glow: '#DC2626' },
  { id: 'gas_mask', name: 'Gas Mask', color: '#27272A' },
  { id: 'cyber_helmet', name: 'Cyber Helmet', color: '#1a1a1a', glow: '#9333EA' },
  { id: 'crown', name: 'Crown', color: '#FCD34D' },
  { id: 'snapback', name: 'Snapback', color: '#1a1a1a' },
  { id: 'headphones', name: 'Headphones', color: '#374151' },
  { id: 'bandana', name: 'Bandana', color: '#DC2626' },
  { id: 'mohawk', name: 'Mohawk', color: '#22C55E' },
  // ========== NEW: Roster-inspired hats ==========
  { id: 'fedora_brown', name: 'Brown Fedora', color: '#78492A' },
  { id: 'cowboy_hat', name: 'Cowboy Hat', color: '#5C4732' },
  { id: 'hard_hat_yellow', name: 'Hard Hat', color: '#F59E0B' },
  { id: 'sailor_cap', name: 'Sailor Cap', color: '#FAFAFA' },
  { id: 'sombrero', name: 'Sombrero', color: '#FACC15' },
  { id: 'astronaut_helmet', name: 'Astronaut Helmet', color: '#E5E7EB', glow: '#FFFFFF' },
  { id: 'wizard_hat', name: 'Wizard Hat', color: '#5B21B6', glow: '#7C3AED' },
  { id: 'elf_hat', name: 'Elf Hat', color: '#16A34A' },
  { id: 'knight_helm', name: 'Knight Helm', color: '#B91C1C', glow: '#FCD34D' },
  { id: 'aviator_goggles', name: 'Aviator Goggles', color: '#5C4732' },
  { id: 'ninja_mask', name: 'Ninja Mask', color: '#0a0a0a' },
  { id: 'doctor_headlight', name: 'Doctor Headlight', color: '#FAFAFA', glow: '#FFFFFF' },
  { id: 'cop_cap', name: 'Officer Cap', color: '#1E40AF' },
  { id: 'steampunk_goggles', name: 'Steampunk Goggles', color: '#92400E', glow: '#F59E0B' },
  // Premium items (purchasable with VibeCoins)
  { id: 'angel_wings', name: '👼 Angel Wings', color: '#F0F0FF', glow: '#FFFFFF', premium: true, price: 500 },
  { id: 'demon_wings', name: '😈 Demon Wings', color: '#7F1D1D', glow: '#DC2626', premium: true, price: 500 },
  { id: 'neon_mohawk', name: '⚡ Neon Mohawk', color: '#FF00FF', glow: '#FF00FF', premium: true, price: 300 },
  { id: 'vip_crown', name: '👑 VIP Crown', color: '#FFD700', glow: '#FFA500', premium: true, price: 1000 },
  { id: 'fire_aura', name: '🔥 Fire Aura', color: '#FF4500', glow: '#FF6B00', premium: true, price: 750 },
  { id: 'ice_crown', name: '❄️ Ice Crown', color: '#87CEEB', glow: '#00FFFF', premium: true, price: 600 },
  { id: 'turtle_shell', name: '🐢 Turtle Man\'s Shell Hat', color: '#2D6A4F', glow: '#52B788', premium: true, price: 350 },
];

// Premium Accessories (separate from hats)
export const OUTFIT_ACCESSORIES = [
  { id: 'none', name: 'None', color: 'transparent' },
  { id: 'chain_gold', name: 'Gold Chain', color: '#FFD700' },
  { id: 'chain_silver', name: 'Silver Chain', color: '#C0C0C0' },
  { id: 'glow_stick', name: 'Glow Stick', color: '#39FF14', glow: '#39FF14' },
  { id: 'sunglasses', name: 'Sunglasses', color: '#1a1a1a' },
  { id: 'face_mask', name: 'Face Mask', color: '#1a1a1a' },
  // Premium accessories
  { id: 'diamond_chain', name: '💎 Diamond Chain', color: '#E0FFFF', glow: '#00FFFF', premium: true, price: 800 },
  { id: 'laser_glasses', name: '🔴 Laser Glasses', color: '#FF0000', glow: '#FF0000', premium: true, price: 400 },
  { id: 'holo_wings', name: '🦋 Holo Wings', color: '#9400D3', glow: '#BA55D3', premium: true, price: 900 },
  { id: 'fire_trail', name: '🔥 Fire Trail', color: '#FF4500', glow: '#FF6B00', premium: true, price: 600 },
  { id: 'sparkle_aura', name: '✨ Sparkle Aura', color: '#FFD700', glow: '#FFF8DC', premium: true, price: 450 },
];
